/**
 * Milliseconds to Human readable
 */
export default function ms2hr(ms = 0) {
    if (ms === null || ms === undefined) {
        return "...";
    } else if (isNaN(ms)) {
        return `0s`;
    }

    const DLength = 86400000;
    const hLength = 3600000;
    const mLength = 60000;
    const sLength = 1000;

    let D = 0,
        h = 0,
        m = 0,
        s = 0;

    ms -= DLength * (D = Math.floor(ms / DLength));
    ms -= hLength * (h = Math.floor(ms / hLength));
    ms -= mLength * (m = Math.floor(ms / mLength));
    ms -= sLength * (s = Math.floor(ms / sLength));

    return (
        [D > 0 ? `${D}d` : null, h > 0 ? `${h}h` : null, m > 0 ? `${m}m` : null, s > 0 ? `${s}s` : null]
            .filter(v => v)
            .join(" ")
            .trim() || "0s"
    );
}
